<template>
  <v-container>
    <v-row class="pa-4" justify="space-between">
      <div>
        <h2 class="primary--text">
          Dossiers
        </h2>
        <span>{{ filtered_dossiers.length }} dossier(s) sélectionné(s)</span>
      </div>
      <div>
        <v-progress-circular indeterminate color="primary" v-if="loading"></v-progress-circular>
      </div>
      <v-btn to="/dossier/create" color="secondary" class="white--text">
        <v-icon>mdi-plus</v-icon>
        Créer un dossier
      </v-btn>

    </v-row>
    <h2 class="pa-0">Champs actifs</h2>
    <v-checkbox dense v-model="active_fields.statut_pret" label="Étude de prêt"></v-checkbox>
    <v-row class="my-2" justify="space-around" align="center" v-if="showScroll">
      <v-icon @click="scrollLeft" color="primary">mdi-chevron-left</v-icon>
      <v-spacer></v-spacer>
      <v-icon @click="scrollRight" color="primary">mdi-chevron-right</v-icon>
    </v-row>
    <v-simple-table ref="table" class="overflow-x-auto overflow-y-auto">
      <template v-slot:default>
        <thead>
        <tr class="primary">
          <th class="white--text text-left">Numéro de dossier</th>
          <th class="white--text text-left">Nom</th>
          <th class="white--text text-left">Prénom</th>
          <th class="white--text text-left">Référence</th>
          <th class="white--text text-left">Statut</th>
          <th v-if="active_fields.statut_pret" class="white--text text-left">Statut de prêt</th>
          <th class="white--text text-left">Ville du bien immobilier</th>
          <th class="white--text text-left">Montant des travaux</th>
          <th class="white--text text-left">Date d'arrêté</th>
          <th class="white--text text-left">Instructeur</th>
          <th class="white--text text-left">Enquêteur</th>
          <th class="white--text"></th>
        </tr>
        <tr>
          <th class="text-left">
            <v-text-field background-color="white" v-model="id_filter" label="ID"></v-text-field>
          </th>
          <th class="text-left">
            <v-text-field background-color="white" v-model="last_name_filter"
                          label="Nom"></v-text-field>
          </th>
          <th class="text-left">
            <v-text-field background-color="white" v-model="first_name_filter"
                          label="Prénom"></v-text-field>
          </th>
          <th class="text-left">
            <v-text-field background-color="white" v-model="reference_filter" label="Référence"></v-text-field>
          </th>
          <th class="text-left">
            <v-select background-color="white" label="Statut" v-model="statut_filter" :items="statuts"
                      multiple deletable-chips chips small-chips
                      item-text="name"
                      item-value="id"></v-select>
          </th>
          <th  v-if="active_fields.statut_pret" class="text-left">
            <v-select background-color="white" label="Statut de prêt" v-model="statut_pret_filter" :items="statut_pret_select"
                      item-text="name"
                      item-value="value"></v-select>
          </th>
          <th class="text-left">
            <v-select v-model="ville_filter" multiple small-chips deletable-chips background-color="white"
                      label="Villes" :items="villes" item-text="name"
                      item-value="value"></v-select>
          </th>
          <!--            <th class="text-left">
                        <v-text-field v-model="reference_filter" background-color="white" label="Référence"></v-text-field>
                      </th>-->
          <th>
            <v-range-slider
                :hint="montant_filter_display"
                v-model="montant_filter"
                max="100000"
                min="0"
            ></v-range-slider>
          </th>
          <th>
            <v-select :items="years" v-model="arrete_filter" label="Date d'arrêté"></v-select>
          </th>
          <th class="text-left">
            <v-select v-model="instructeur_filter" background-color="white" label="Instructeur" :items="instructeurs"
                      multiple small-chips deletable-chips
                      item-text="fullname"
                      item-value="id"></v-select>
          </th>
          <th class="text-left">
            <v-select v-model="enqueteur_filter" background-color="white" label="Enquêteur" :items="enqueteurs"
                      multiple small-chips deletable-chips></v-select>
          </th>
          <th>
            <v-tooltip bottom color="white">
              <template v-slot:activator="{on, attrs}">
                <v-btn @click="removeFilters" v-on="on" v-bind="attrs" color="red" text>
                  <v-icon>mdi-trash-can</v-icon>
                </v-btn>
              </template>
              <span class="text-uppercase red--text">Effacer les filtres</span>
            </v-tooltip>
          </th>
        </tr>
        <tr v-if="selected_dossiers.length > 0" style="background: #A5D8D2">
          <td colspan="1">
            <v-checkbox v-model="selectAll" label="Sélectionner tout"></v-checkbox>
          </td>
          <td colspan="2" class="text-center">
            <h3 class="primary--text">Modifier plusieurs dossiers</h3>
          </td>
          <td colspan="2">
            <v-select background-color="white" return-object label="Statut" v-model="statutMultiple" :items="statuts"
                      item-text="name"
                      item-value="id"></v-select>
          </td>
          <td colspan="2">
            <v-select v-model="instructeurMultiple" background-color="white" label="Instructeur" :items="instructeurs"
                      item-text="fullname"
                      item-value="id"></v-select>
          </td>
          <td colspan="2">
            <v-btn @click="editMultipleDossiers" :disabled="editing" :color="editing ? 'grey' : 'primary'" text>
              <v-icon>mdi-pencil</v-icon>
              Modifier les dossiers sélectionnés
            </v-btn>
            <v-progress-circular indeterminate color="primary" v-if="editing"></v-progress-circular>
          </td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(dossier, index) in filtered_dossiers" :key="index">
          <td>

            <v-row justify="center" align="center">
              <v-tooltip left>
                <template v-slot:activator="{on, attrs}">
                  <div v-bind="attrs" v-on="on">
                    <v-checkbox class="white mt-0 d-inline" v-model="selected_dossiers"
                                :value="dossier.id"></v-checkbox>
                  </div>
                </template>
                <span class="white--text">Modifier le dossier</span>
              </v-tooltip>
              <h4 class="secondary--text">
                <router-link class="text-decoration-none secondary--text" :to="`/dossier/${dossier.id}`">
                  #{{ dossier.id }}
                </router-link>
              </h4>
            </v-row>

          </td>
          <td>
            <v-tooltip top>
              <template v-slot:activator="{on, attrs}">
                <h4 class="primary--text" v-bind="attrs" v-on="on">
                  <router-link class="text-decoration-none" :to="`/dossier/${dossier.id}`">{{
                      dossier.beneficiaire_last_name
                    }}
                  </router-link>
                </h4>
              </template>
              <h4 class="white--text">
                {{
                  dossier.beneficiaire_last_name
                }}
              </h4>
            </v-tooltip>
          </td>
          <td>
            <v-tooltip top>
              <template v-slot:activator="{on, attrs}">
                <h4 class="primary--text" v-bind="attrs" v-on="on">
                  <router-link class="text-decoration-none" :to="`/dossier/${dossier.id}`">{{
                      dossier.beneficiaire_first_name
                    }}
                  </router-link>
                </h4>
              </template>
              <h4 class="white--text">
                {{
                  dossier.beneficiaire_first_name
                }}
              </h4>
            </v-tooltip>
          </td>
          <td>
            <span class="grey--text">{{ dossier.reference }}</span>
          </td>
          <td>
            <v-chip class="blue accent-4 white--text mt-n1">{{ dossier.current_statut }}</v-chip>
          </td>
          <td v-if="active_fields.statut_pret">
            <span class="grey--text">{{dossier.statut_pret}}</span>
          </td>
          <td><span class="grey--text">{{ dossier.beneficiaire_ville }}</span></td>
          <td><span>{{ dossier.montant_travaux }} €</span></td>
          <td><span>{{ getFormattedDate(dossier.date_arrete) }}</span></td>
          <td>
            <v-chip class="primary white--text">
              <span v-if="dossier.instructeur !== null">{{
                  dossier.instructeur.first_name
                }} {{ dossier.instructeur.last_name }}</span>
              <span v-else>Non défini</span>
            </v-chip>
          </td>
          <td>
            <v-chip v-if="dossier.enqueteur" class="grey darken-3 white--text">
              {{ dossier.enqueteur_name }}
            </v-chip>
          </td>
          <td></td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-container>
</template>

<script>
import {AuthMixin} from "@/mixins/AuthMixin";
import {convertStringListToSelect} from "@/util";
import {VILLES} from "@/constants/Villes";
import {DateUtilMixin} from "@/mixins/DateUtilMixin";
import dayjs from "dayjs";

export default {
  name: 'Dossiers',
  mixins: [AuthMixin, DateUtilMixin],
  async mounted() {
    this.loading = true;
    if (this.$store.getters["dossier/getDossiers"].length === 0) {
      await this.$store.dispatch("dossier/fetchDossiers");
    }
    if(this.$store.getters["select/selects"].length === 0) {
      await this.$store.dispatch("select/fetchSelects");
    }
    let arrete = this.$route.query?.arrete;
    if (arrete !== undefined) {
      if (arrete === "absent") {
        this.arrete_filter = "Sans arrêté";
      } else {
        try {
          this.arrete_filter = parseInt(arrete);
        } catch (e) {
          this.arrete_filter = null;
        }
      }
    }
    let statusFetchStatus = this.$store.getters["dossier/statuts/statut_fetch_status"];
    if (statusFetchStatus === "INITIAL" || statusFetchStatus === "ERROR") {
      await this.$store.dispatch("dossier/statuts/getStatuts");
    }
    let statut = this.$route.query?.statut;
    if (statut !== undefined) {
      if (statut === "chantier") {
        console.log("On charge pour les chantier")
        this.statut_filter = this.statuts
            .filter((statut_obj) => statut_obj.numerical_value >= 12 && statut_obj.numerical_value <= 15)
            .map((s) => s.id);
      } else if (statut === "prospects") {
        this.statut_filter = this.statuts
            .filter((statut_obj) => statut_obj.numerical_value >= 1 && statut_obj.numerical_value < 3)
            .map((s) => s.id);
      } else {
        this.statut_filter = [parseInt(statut)]
      }
    }
    let userFetchStatus = this.$store.getters["users/loading_status"];
    if (userFetchStatus === "INITIAL" || userFetchStatus === "ERROR") {
      await this.$store.dispatch("users/fetchUsers");
    }
    this.loading = false;
    await this.$nextTick();
    this.table = document.querySelector(".v-data-table__wrapper");
  },
  data() {
    return {
      statut_filter: [],
      statut_pret_filter: null,
      table: null,
      first_name_filter: "",
      last_name_filter: "",
      reference_filter: "",
      instructeur_filter: [],
      ville_filter: [],
      mo_filter: null,
      enqueteur_filter: [],
      arrete_filter: null,
      reference: "",
      dialog: false,
      loading: false,
      editing: false,
      selected_dossiers: [],
      statutMultiple: null,
      instructeurMultiple: null,
      viewStyle: 'table',
      id_filter: null,
      montant_filter: [0, 100000],
      selectAll: false,
      active_fields: {
        statut_pret: false,
      }
    }
  },
  computed: {
    dossiers() {
      return this.$store.getters["dossier/getDossiers"];
    },
    filtered_dossiers() {
      return this.dossiers
          .filter((dossier) => this.statut_filter.length !== 0 ? this.statut_filter.indexOf(dossier.statut_id) !== -1 : true)
          .filter((dossier) => this.first_name_filter !== "" ? dossier.beneficiaire_first_name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(this.first_name_filter.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()) : true)
          .filter((dossier) => this.last_name_filter !== "" ? dossier.beneficiaire_last_name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(this.last_name_filter.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()) : true)
          .filter((dossier) => this.reference_filter !== "" ? dossier.reference.toLowerCase().includes(this.reference_filter.toLowerCase()) : true)
          .filter((dossier) => this.instructeur_filter.length !== 0 && !this.instructeur_filter.includes("") ? this.instructeur_filter.includes(dossier.instructeur?.id) : true)
          .filter((dossier) => this.enqueteur_filter.length !== 0 && !this.enqueteur_filter.includes("") ? this.enqueteur_filter.includes(dossier.enqueteur) : true)
          .filter((dossier) => this.ville_filter.length !== 0 ? this.ville_filter.includes(dossier.beneficiaire_ville) : true)
          .filter((dossier) => this.id_filter ? dossier.id.toString() === this.id_filter : true)
          .filter((dossier) => this.montant_filter[0] <= dossier.montant_travaux && this.montant_filter[1] >= dossier.montant_travaux)
          .filter((dossier) => this.arrete_filter !== null ? this.arrete_filter === "Sans arrêté" ? dossier.date_arrete === null : dayjs(dossier.date_arrete).year() === this.arrete_filter : true)
          .filter((dossier) => this.statut_pret_filter !== null ? dossier.statut_pret === this.statut_pret_filter : true);
    },
    statuts() {
      return this.$store.getters["dossier/statuts/statuts"];
    },
    statut_pret_select() {
      let statutsPret = this.$store.getters["select/statut_pret_types"].map((statut) => ({value: statut.value, name: statut.value}));
      return [{value: null, name: 'Tout les statuts'}, ...statutsPret];
    },
    instructeurs() {
      return [{fullname: "Tous les instructeurs", id: ""}, ...this.$store.getters["users/instructeurs"]];
    },
    enqueteurs() {
      return ["", ...this.$store.getters["select/enqueteurs"]];
    },
    years() {
      return ["Sans arrêté", ...this.dossiers.filter((d) => d.date_arrete !== null).map((d) => dayjs(d.date_arrete).year())];
    },
    villes() {
      return [{
        value: null,
        name: "Toutes les villes"
      }, ...convertStringListToSelect(Object.keys(VILLES["Martinique"]))];
    },
    montant_filter_display() {
      return `${this.montant_filter[0]} € - ${this.montant_filter[1]} €`
    },
    showScroll() {
      return this.table !== null ? this.table.scrollWidth > this.table.clientWidth : false;
    }
  },
  methods: {
    createDossier() {
      if (this.$refs.createDossierForm.validate()) {
        let dossier = {
          reference: this.reference,
          instructeur: this.logged_user.id,
        }
        this.$store.dispatch("dossier/postDossier", dossier);
        this.$store.dispatch("annonce/annonceSuccess", "Dossier créé.", {root: true})
        this.dialog = false;
      }
    },
    findStatut(statut) {
      let statut_text = this.statut_select.find((item) => item.value === statut);
      return statut_text != null ? statut_text : statut;
    },
    removeFilters() {
      this.statut_filter = [];
      this.statut_pret_filter = null;
      this.beneficiaire_filter = "";
      this.first_name_filter = "";
      this.last_name_filter = "";
      this.reference_filter = "";
      this.instructeur_filter = [];
      this.ville_filter = [];
      this.id_filter = null;
      this.montant_filter = [0, 100000];
      this.enqueteur_filter = [];
      this.arrete_filter = null;
    },
    async editMultipleDossiers() {
      this.editing = true;
      let dossierUpdate = {};
      if (this.statutMultiple !== null) {
        dossierUpdate.statut = this.statutMultiple.id;
      }
      if (this.instructeurMultiple !== null) {
        dossierUpdate.instructeur = this.instructeurMultiple;
      }
      for (let dossier_id of this.selected_dossiers) {
        await this.$store.dispatch("dossier/patchDossier", {id: dossier_id, ...dossierUpdate});
      }
      await this.$store.dispatch("dossier/fetchDossiers");
      this.loading = false;
      this.selected_dossiers = [];
      this.statutMultiple = null;
      this.instructeurMultiple = null;
      this.editing = false;
      await this.$store.dispatch("annonce/annonceSuccess", "Dossiers mis à jour.");
    },
    scrollRight() {
      if (!this.table) return;
      this.table.scrollTo({top: this.table.clientHeight, left: this.table.scrollWidth, behavior: "smooth"});
    },
    scrollLeft() {
      if (!this.table) return;
      this.table.scrollTo({top: this.table.clientHeight, left: 0, behavior: "smooth"});
    }
  },
  watch: {
    selectAll(value) {
      if (value === true) {
        this.selected_dossiers = this.filtered_dossiers.map((dossier) => dossier.id);
      } else {
        this.selected_dossiers = [];
      }
    },
    selected_dossiers(value) {
      if(value === null) {
        this.selected_dossiers = [];
      }
    },
    instructeur_filter(value, oldvalue) {
      if (value.indexOf("") !== -1 && oldvalue.indexOf("") === -1) {
        this.instructeur_filter = [""];
      }
      if (oldvalue.indexOf("") !== -1 && oldvalue.length === 1 && value.length > 1) {
        this.instructeur_filter = this.instructeur_filter.filter(item => item !== "");
      }
    },
    enqueteur_filter(value, oldvalue) {
      if (value.indexOf("") !== -1 && oldvalue.indexOf("") === -1) {
        this.enqueteur_filter = [""];
      }
      if (oldvalue.indexOf("") !== -1 && oldvalue.length === 1 && value.length > 1) {
        this.enqueteur_filter = this.enqueteur_filter.filter(item => item !== "");
      }
    }
  }
}
</script>
<style scoped>
</style>
